import { render } from "./skuProdutos.vue?vue&type=template&id=0f46cac8&scoped=true"
import script from "./skuProdutos.vue?vue&type=script&lang=js"
export * from "./skuProdutos.vue?vue&type=script&lang=js"

import "./skuProdutos.vue?vue&type=style&index=0&id=0f46cac8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f46cac8"]])

export default __exports__